import AppProjectPage from "../app"
import ProjectPageSettingsManager from "../settings/settings-manager"

// const debug = "page_toggleCreatedBy"
const debug = false

export default function page_toggleCreatedBy(value: boolean) {
    const app: AppProjectPage = gd.getMainApp() as AppProjectPage
    const settings: ProjectPageSettingsManager = app.settings as ProjectPageSettingsManager

    const newValue       = !_.isNil(value) ? value : !settings.showCreatedBy
    const isValueChanged = settings.showCreatedBy !== newValue
    settings.showCreatedBy = newValue

    debug && console.log(debug, 'process', value, newValue, settings.showCreatedBy)

    if (isValueChanged) {
        app.render()
    }
}